import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { QRCodeOpenComponent } from '../../qr/qrcode-open.component';

@Component({
    selector: 'convfact-expense-selector',
    templateUrl: './expense-selector.component.html',
    styleUrls: ['./expense.component.css'],
    standalone: false
})
export class ExpenseSelectorComponent {

  constructor(
    private router: Router,
    public dialog: MatDialog
  ) { }

  goQR() {
    this.dialog.open(QRCodeOpenComponent, {
      panelClass: 'full-screen',
    });
  }

  goCreate() {
    this.router.navigate(['/expense/create/']);
  }

}